import appConstants from "../../../../../../appConstants";
import { MultiSelectFilter } from "../../../../../dataGrid/columnFilters";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import ToolTip from "../../../../../common/StyledToolTip";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration(config) {
    return GridConfig.getDefaultConfiguration();
  }

  static showTerminalStatus = (params) => {
    return (
      <ToolTip title={params.value ? "Enable" : "Disabled"}>
        <div style={{ padding: "5px 0px" }}>
          <FiberManualRecordIcon
            color={params.value ? "primary" : "secondary"}
          />
        </div>
      </ToolTip>
    );
  };

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.onboardTerminalGrid,
      keyColumn: "onboardTerminalName",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columns: [
        {
          headerName: "Status",
          field: "isEnabled",
          cellClass: "gridCell-leftAlign",
          cellRendererFramework: GridConfig.showTerminalStatus,
          minWidth: appConstants.columnWidth.W_70,
        },
        {
          headerName: "Terminal",
          field: "terminalName",
          minWidth: appConstants.columnWidth.W_200,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Terminal Code",
          field: "terminalCode",
          minWidth: appConstants.columnWidth.W_100,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Region",
          field: "regionName",
          minWidth: appConstants.columnWidth.W_100,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Division",
          field: "divisionName",
          minWidth: appConstants.columnWidth.W_100,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Address",
          field: "address",
          minWidth: appConstants.columnWidth.W_200,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "City",
          field: "city",
          minWidth: appConstants.columnWidth.W_180,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "State",
          field: "state",
          minWidth: appConstants.columnWidth.W_120,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Country",
          field: "country",
          minWidth: appConstants.columnWidth.W_120,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Zip Code",
          field: "zip",
          minWidth: appConstants.columnWidth.W_120,
          filterFramework: MultiSelectFilter,
        },
      ],
    };
  }
}
